import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ccb582a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "virtual-avatar" }
const _hoisted_2 = { class: "avatars" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]

import { ref } from 'vue'
import {
    Button,
    Input,
    message,
} from 'ant-design-vue'

interface AvatarItem {
    id: number
    label: string
    src: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VirtualAvatar',
  emits: ["insertAvatar", "close"],
  setup(__props, { emit }: { emit: ({
    (event: 'insertAvatar', payload: string): void
    (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const avatars: AvatarItem[] = [
    { id: 1, label: '头像1', src: "https://admin-yaochuang-tech.oss-cn-shanghai.aliyuncs.com/admin/202212/270fbb51ba0ad5be9464ae7b67420e9c.jpg" },
    { id: 2, label: '头像2', src: "https://admin-yaochuang-tech.oss-cn-shanghai.aliyuncs.com/admin/202212/270fbb51ba0ad5be9464ae7b67420e9c.jpg" },
]



const insertAvatar = (src: string) => {
    if (!src) return message.error('请先选择虚拟头像')
    emit('insertAvatar', src)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(avatars, (avatar) => {
        return _createElementVNode("div", {
          class: "avatar",
          key: avatar.id,
          onClick: ($event: any) => (insertAvatar(avatar.src))
        }, [
          _createElementVNode("img", {
            src: avatar.src
          }, null, 8, _hoisted_4)
        ], 8, _hoisted_3)
      }), 64))
    ])
  ]))
}
}

})